/* Soccer Sport MX — mejoras de conversión y atribución */
(function () {
  'use strict';

  if (window.__ssmxConversionFixesReady) return;
  window.__ssmxConversionFixesReady = true;

  function removeLegacySchema() {
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (script) {
      var content = script.textContent || '';
      if (
        content.indexOf('"@type": "Store"') !== -1 &&
        content.indexOf('"opens": "11:00"') !== -1
      ) {
        script.remove();
      }
    });
  }

  function unlockCheckout() {
    document.querySelectorAll('.term-conditions-checkbox-js').forEach(function (element) {
      element.remove();
    });

    document.querySelectorAll('button[name="checkout"]').forEach(function (button) {
      button.disabled = false;
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
    });

    document.querySelectorAll('.buyinoneclick').forEach(function (container) {
      var productArea = container.closest('.tt-product-single-info, form, .tt-product-single-img');
      var addButton = productArea
        ? productArea.querySelector('button[name="add"], .addtocart')
        : null;
      var productCanBePurchased = !addButton || !addButton.disabled;

      if (!productCanBePurchased) return;

      container.style.display = '';
      container.querySelectorAll('.shopify-payment-button__button').forEach(function (button) {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      });
    });
  }

  function addCartAssurance() {
    document.querySelectorAll('button[name="checkout"]').forEach(function (button) {
      if (button.parentElement.querySelector('.ssmx-cart-assurance')) return;

      var message = document.createElement('p');
      message.className = 'ssmx-cart-assurance';
      message.innerHTML =
        '<strong>Compra protegida y pago seguro</strong>' +
        'Envío estimado de 1 a 2 días hábiles · ' +
        '<a href="/pages/devoluciones">Cambios en productos sin uso</a>';
      button.parentElement.insertBefore(message, button);
    });
  }

  function readCampaignData() {
    var params = new URLSearchParams(window.location.search);
    var data = {
      source: params.get('utm_source') || '',
      medium: params.get('utm_medium') || '',
      campaign: params.get('utm_campaign') || '',
      content: params.get('utm_content') || ''
    };

    if (!data.source && params.get('fbclid')) data.source = 'facebook';
    if (!data.source && params.get('gclid')) data.source = 'google';

    var hasCampaignData = Object.keys(data).some(function (key) {
      return Boolean(data[key]);
    });

    if (hasCampaignData) {
      try {
        sessionStorage.setItem('ssmx_campaign_attribution', JSON.stringify(data));
      } catch (error) {
        return data;
      }
      return data;
    }

    try {
      var saved = sessionStorage.getItem('ssmx_campaign_attribution');
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      return null;
    }
  }

  function saveCampaignToCart() {
    var data = readCampaignData();
    if (!data || !data.source) return;

    var fingerprint = [data.source, data.medium, data.campaign, data.content].join('|');
    try {
      if (sessionStorage.getItem('ssmx_campaign_saved') === fingerprint) return;
    } catch (error) {
      /* Continue without session deduplication. */
    }

    var root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          'Fuente de campaña': data.source,
          'Medio de campaña': data.medium,
          'Campaña': data.campaign,
          'Contenido de campaña': data.content
        }
      })
    }).then(function (response) {
      if (!response.ok) return;
      try {
        sessionStorage.setItem('ssmx_campaign_saved', fingerprint);
      } catch (error) {
        /* Attribution was still saved to the cart. */
      }
    }).catch(function () {
      /* A failed attribution request must never interrupt shopping. */
    });
  }

  function applyFixes() {
    removeLegacySchema();
    unlockCheckout();
    addCartAssurance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyFixes();
      saveCampaignToCart();
      window.setTimeout(applyFixes, 350);
      window.setTimeout(applyFixes, 1000);
    });
  } else {
    applyFixes();
    saveCampaignToCart();
  }

  var observer = new MutationObserver(function () {
    applyFixes();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.setTimeout(function () {
    observer.disconnect();
  }, 5000);
}());
